import { toast } from 'bulma-toast';

const BASE_CONFIG = {
  dismissible: true,
  pauseOnHover: true,
  animate: { in: 'fadeIn', out: 'fadeOut' },
  position: 'top-center',
  closeOnClick: true,
  duration: 5000,
};

const notify = (type) => (message) => toast({ ...BASE_CONFIG, type, message });

export const showWarning = notify('is-warning');
export const showSuccess = notify('is-success');
export const showError = notify('is-danger');
